<template>
  <div />
</template>

<script>
import AccountManageCompanies from './AccountManageCompanies.svelte'

export default {
  props: {
    state: {
      type: String,
      required: true
    },
    userAccount: {
      type: Object,
      default: () => ({}),
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    state() {
      this.updateSvelteProps();
    },
    userAccount() {
      this.updateSvelteProps();
    },
    isAdmin() {
      this.updateSvelteProps();
    }
  },

  async mounted() {
    try {
      this.svelteComponent = new AccountManageCompanies({
        target: this.$el,
        props: this.createProps(),
      });
    } catch (e){
      // eslint-disable-next-line no-console
      console.error('Component failed to load');
      // eslint-disable-next-line no-console
      console.error(e);
    }
  },

  destroyed() {
    if(this.svelteComponent){
      this.svelteComponent.$destroy();
    }
  },

  methods: {
    updateSvelteProps(){
      if(this.svelteComponent){
        this.svelteComponent.$set(this.createProps());
      }
    },
    createProps(){
      return JSON.parse(JSON.stringify({
          state: this.state,
          userAccount: this.userAccount,
          isAdmin: this.isAdmin,
        }));
    }
  }
}
</script>
